import React from 'react'
import ClientTypesConstants from '../../../../../../constants/ClientTypes'
import ClientUrlTypesConstants from '../../../../../../constants/ClientUrlTypesConstants'
import TextInputList from '../../../../TextInputList'

const ClientUrls = ({ formData, formErrors, onChange, disabled, clientType }) => {

  const onClientUrlsChange = (urls, clientUrlType) => {
    if (clientUrlType === ClientUrlTypesConstants.REDIRECT) {
      onChange("redirectUrls", urls)
    }
    if (clientUrlType === ClientUrlTypesConstants.CORS) {
      onChange("corsUrls", urls)
    }
    if (clientUrlType === ClientUrlTypesConstants.LOGOUT) {
      onChange("logoutUrls", urls)
    }
  }

  const getValues = (clientUrlType) => {
    return formData?.clientUrls?.filter(url => url.type === clientUrlType)
  }

  const getErrors = (clientUrlType) => {
    const errorObject = formErrors?.clientUrls?.message

    if (clientUrlType === ClientUrlTypesConstants.REDIRECT) {
      return errorObject?.redirectUrls
    }
    if (clientUrlType === ClientUrlTypesConstants.CORS) {
      return errorObject?.corsUrls
    }
    if (clientUrlType === ClientUrlTypesConstants.LOGOUT) {
      return errorObject?.logoutUrls
    }
  }

  if (!formData?.clientUrls) {
    return null
  }

  return (
    <div className="client-urls-component-container">
      <TextInputList 
        displayName="Redirect Urls"
        placeholder="Eg: https://example.com/redirect"
        values={getValues(ClientUrlTypesConstants.REDIRECT)}
        errors={getErrors(ClientUrlTypesConstants.REDIRECT)}
        onChange={(urls) => onClientUrlsChange(urls, ClientUrlTypesConstants.REDIRECT)}
        disabled={disabled}
      />
      <TextInputList 
        displayName="Logout Urls"
        placeholder="Eg: https://example.com/logout"
        values={getValues(ClientUrlTypesConstants.LOGOUT)}
        errors={getErrors(ClientUrlTypesConstants.LOGOUT)}
        onChange={(urls) => onClientUrlsChange(urls, ClientUrlTypesConstants.LOGOUT)}
        disabled={disabled}
      />
      {clientType === ClientTypesConstants.SPA && (
        <TextInputList 
          displayName="Cors Urls"
          placeholder="Eg: https://example.com"
          values={getValues(ClientUrlTypesConstants.CORS)}
          errors={getErrors(ClientUrlTypesConstants.CORS)}
          onChange={(urls) => onClientUrlsChange(urls, ClientUrlTypesConstants.CORS)}
          disabled={disabled}
        />
      )}
    </div>
  )
}

export default ClientUrls
